import PropTypes from 'prop-types';

import { Box, Button, Checkbox, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import ExpandableImageComponent from '../../Image/ExpandableImageComponent';

import { avatarPlaceholderSRC, formatDate } from '../../../utils';

import { OutgoingPackageIcon } from '../Packages/OutgoingPackageIcon';

const StyledDeliveryButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isChecked',
})(({ theme, isChecked }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'left',
  padding: '1rem',
  backgroundColor: theme.palette.custom.grey,
  ...(isChecked && {
    backgroundColor: theme.palette.custom.lightGreen,
    '&:hover': {
      backgroundColor: theme.palette.custom.lightGreen,
    },
  }),
}));

const DeliveryComponent = ({
  delivery,
  onDeliverySignOutChange,
  isChecked,
  isSelfSignOut,
}) => {
  const { type, unitName, createdAt, pickUp } = delivery;
  const deliveryLogo = type?.icons?.[0];
  const deliveryType = pickUp
    ? `${type?.displayName} (outgoing)`
    : type?.displayName;

  return (
    <StyledDeliveryButton
      isChecked={isChecked}
      color="inherit"
      onClick={() => onDeliverySignOutChange(delivery, !isChecked)}
      fullWidth
    >
      <Box mr="1rem">
        <Checkbox
          sx={(theme) => [
            isChecked && {
              color: theme.palette.custom.green,
            },
          ]}
          color="default"
          checked={isChecked}
        />
      </Box>
      <Box
        sx={{
          marginRight: '1rem',
          position: 'relative',
        }}
      >
        <ExpandableImageComponent
          src={avatarPlaceholderSRC}
          photo={deliveryLogo}
          caption={type?.displayName}
          height="3.2rem"
          isSquare
        />
        {pickUp ? <OutgoingPackageIcon /> : null}
      </Box>
      <Typography textAlign="left">
        <Box sx={{ display: 'block', lineHeight: '1.6rem' }}>
          {isSelfSignOut
            ? `${deliveryType}`
            : `${deliveryType} · ${unitName ?? 'No unit'}`}
        </Box>
        <Box sx={{ fontSize: '1.2rem', lineHeight: '2rem' }}>
          {formatDate(createdAt, true, '[Added] M/D/YY [at] h:mm A')}
        </Box>
      </Typography>
    </StyledDeliveryButton>
  );
};

DeliveryComponent.defaultProps = {};

DeliveryComponent.propTypes = {
  delivery: PropTypes.instanceOf(Object).isRequired,
  onDeliverySignOutChange: PropTypes.func.isRequired,
  isChecked: PropTypes.bool.isRequired,
  isSelfSignOut: PropTypes.bool,
};

export default DeliveryComponent;
